import { render, staticRenderFns } from "./VotingFormClosed.vue?vue&type=template&id=284e6586&scoped=true"
import script from "./VotingFormClosed.vue?vue&type=script&lang=js"
export * from "./VotingFormClosed.vue?vue&type=script&lang=js"
import style0 from "./VotingFormClosed.vue?vue&type=style&index=0&id=284e6586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e6586",
  null
  
)

export default component.exports